import React, { useEffect, useState } from "react";
import { Popup, Position, ToolbarItem } from "devextreme-react/popup";
import { useDispatch, useSelector } from "react-redux";
import {
  getResourceAPI,
  postResource,
  updateResource,
} from "../../redux/slices/resourceSlice";
import { getUIData, setUIData } from "../../redux/slices/uiSlice";
import { getUserId } from "../../redux/slices/userSlice";
import { toCustomDate } from "../../utils/date";
import notify from "devextreme/ui/notify";
import TradeCaseEditor from "./TradeCaseEditor";

const formatData = (data) => {
  return {
    ...data,
    date: data.date || toCustomDate(),
  };
};

const TradeCaseModal = ({
  numOfCases,
  setVisible,
  visible,
  type,
  tradeCaseData,
  selectedTradeCaseId,
  reduxName,
}) => {
  const dispatch = useDispatch();
  const [pending, setPending] = useState(false);
  const data = useSelector((state) => getUIData(state, reduxName));
  const userID = useSelector((state) => getUserId(state));

  useEffect(() => {
    if (type === "edit" && reduxName) {
      dispatch(setUIData({ name: reduxName, value: tradeCaseData }));
    }
  }, [type, dispatch, reduxName, tradeCaseData, userID]);

  const handlePost = () => {
    setPending(true);

    dispatch(
      postResource({
        path: "trade-case",
        data: formatData(data),
      })
    ).then(({ payload }) => {
      if (payload.error) {
        notify(payload.error, "error", 1000);
        setPending(false);
        return;
      }

      const { id } = payload.data;

      dispatch(
        getResourceAPI({
          path: "search",
          query: { our_ref: id },
        })
      ).then(() => setPending(false));

      notify(`Success`, "info", 1000);

      setVisible(false);
    });
  };

  const handleUpdate = () => {
    setPending(true);

    dispatch(
      updateResource({
        id: selectedTradeCaseId,
        path: "trade-case",
        data: formatData(data),
      })
    ).then(({ payload }) => {
      if (payload.error) {
        notify(payload.error, "error", 1000);
        setPending(false);

        return;
      }

      const { id } = payload.data;

      if(numOfCases === 1)
      {
        dispatch(
          getResourceAPI({
            path: "search",
            query: { our_ref: id },
          })
        ).then(() => setPending(false));  
      }
      else{
        setPending(false);
      }

      notify(`Success editing trade case ${selectedTradeCaseId}`, "info", 1000);

      setVisible(false);
    });
  };

  const handleUpsert = () => {
    if (type === "add") handlePost();
    else if (type === "edit") handleUpdate();
  };

  return (
    <Popup
      visible={!!visible}
      closeOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title={`${type} TradeCase`}
      container=".dx-viewport"
      width={500}
      height={650}
    >
      <Position at="center" my="center" />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        options={{
          icon: "save",
          text: "Save",
          onClick: handleUpsert,
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "close",
          text: "Close",
          onClick: () => setVisible(false),
        }}
      />
      {visible && <TradeCaseEditor pending={pending} reduxName={reduxName} />}
    </Popup>
  );
};

export default TradeCaseModal;
